import { render, staticRenderFns } from "./VehicleCreationBox.vue?vue&type=template&id=4810dd48&"
import script from "./VehicleCreationBox.vue?vue&type=script&lang=js&"
export * from "./VehicleCreationBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports